import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import TransactionDetail from "@/pages/TransactionDetail";
import ReviewQueue from "@/pages/ReviewQueue";
import Backtest from "@/pages/Backtest";
import Settings from "@/pages/Settings";
import { isAuthed } from "@/lib/api";

function Guard({ children }) {
  return isAuthed() ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Guard><Layout /></Guard>}>
            <Route index element={<Home />} />
            <Route path="/tx/:id" element={<TransactionDetail />} />
            <Route path="/review" element={<ReviewQueue />} />
            <Route path="/backtest" element={<Backtest />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
